import {NgModule} from '@angular/core';

import {SharedModule} from '../shared/shared.module';

import {
  IamTableComponent,
  IamPeriodComponent,
  IamTreeSelectionComponent,
  CountyGeoComponent,
  TaxAuthorityComponent,
  DialogViewTvanUsingRegisterComponent,
} from './components/entity';
import {SigningComponent} from './components/entity/signing/signing.component';
import {LoadingSpinnerComponent} from './components/entity/signing/loading-spinner.component';

@NgModule({
  declarations: [
    IamTableComponent,
    IamPeriodComponent,
    IamTreeSelectionComponent,
    CountyGeoComponent,
    DialogViewTvanUsingRegisterComponent,
    TaxAuthorityComponent,
    SigningComponent,
    LoadingSpinnerComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    SharedModule,
    IamTableComponent,
    IamPeriodComponent,
    IamTreeSelectionComponent,
    CountyGeoComponent,
    DialogViewTvanUsingRegisterComponent,
    TaxAuthorityComponent,
    SigningComponent,
    LoadingSpinnerComponent
  ]
})
export class EntitiesModule {
}
